import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'gtd-ui-field-special-attachments',
  templateUrl: './attachments.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentsComponent implements OnInit {
  @Input() public data: AttachmentResponse[];
  @Input() title: string;
  @Input() text: string = $localize`:@@common.show:Show`;
  mappedData = [];

  ngOnInit() {
    if (!this.data || !this.data.length) {
      return;
    }

    this.mappedData.push({ name: ' ' });
    this.data.forEach((item) => {
      this.mappedData.push(item);
    });
  }
}

interface AttachmentResponse {
  id: number;
  name: string;
  description: string;
  invoice_id: number;
  created_at: string;
  deleted_at: string;
  updated_at: string;
  file: string;
  type: string;
}
